module.exports = __webpack_public_path__ + "static/img/活動開始囉300x300.872384f0.png";